export var SsoEnforcementRefusalReason;
(function (SsoEnforcementRefusalReason) {
    SsoEnforcementRefusalReason["PROVIDER_MISSING"] = "PROVIDER_MISSING";
})(SsoEnforcementRefusalReason || (SsoEnforcementRefusalReason = {}));
